import { Router } from '@angular/router';
import { AuthenticationService } from './../../../../services/authentication/authentication.service';
import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../../../environments/environment';

import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FuseConfigService } from '../../../../../core/services/config.service';
import { fuseAnimations } from '../../../../../core/animations';
import { NgxPermissionsService } from 'ngx-permissions';
import { TranslateService } from '@ngx-translate/core';
import { FuseTranslationLoaderService } from '../../../../../core/services/translation-loader.service';

import { locale as english } from '../../../../i18n/en';
import { locale as spanish } from '../../../../i18n/es';

@Component({
    selector   : 'fuse-login-2',
    templateUrl: './login-2.component.html',
    styleUrls  : ['./login-2.component.scss'],
    animations : fuseAnimations
})
export class FuseLogin2Component implements OnInit
{
    loginForm: FormGroup;
    loginFormErrors: any;

    public loginModel: any;
    public logo;
    public version;
    public nombreCol;

    constructor(
        private fuseConfig: FuseConfigService,
        private formBuilder: FormBuilder,
        private authenticationService: AuthenticationService,
        private router: Router,
        private ngxPermissionsService: NgxPermissionsService,
        private translate: TranslateService,
    )
    {
        this.fuseConfig.setSettings({
            layout: {
                navigation: 'none',
                toolbar   : 'none',
                footer    : 'none'
            }
        });

        // this.translationLoader.loadTranslations(english, spanish);

        this.loginFormErrors = {
            userName   : {},
            password: {}
        };

        this.loginModel = {
            userName: '',
            password: '',
            loading: false,
            error: false
        };
    }

    ngOnInit()
    {
        this.logo = environment.logo;
        this.version = environment.version;
        this.nombreCol = environment.nombreCol;
        this.loginForm = this.formBuilder.group({
            userName   : ['', [Validators.required]],
            password: ['', Validators.required]
        });

        this.loginForm.valueChanges.subscribe(() => {
            this.onLoginFormValuesChanged();
        });
    }

    onLoginFormValuesChanged()
    {
        for ( const field in this.loginFormErrors )
        {
            if ( !this.loginFormErrors.hasOwnProperty(field) )
            {
                continue;
            }

            // Clear previous errors
            this.loginFormErrors[field] = {};

            // Get the control
            const control = this.loginForm.get(field);

            if ( control && control.dirty && !control.valid )
            {
                this.loginFormErrors[field] = control.errors;
            }
        }
    }

    public login() {
        if (!!this.loginModel && !!this.loginModel.userName && !!this.loginModel.password) {
            //console.log('FuseLogin2Component > login > this.loginModel', this.loginModel);
            this.loginModel.loading = true;
            this.loginModel.error = false;
            this.authenticationService.login(this.loginModel.userName, this.loginModel.password).subscribe(response => {
                //console.log('FuseLogin2Component > login > response', response);
                this.loginModel.loading = false;
                if (response) {
                    let permissions = this.authenticationService.getPermissions();
                    //console.log('FuseLogin2Component > login > permissions', permissions);
                    this.ngxPermissionsService.loadPermissions(permissions);

                    let userLanguage = this.authenticationService.getLanguage();
                    this.translate.use(!!userLanguage && userLanguage.match(/en|es/) ? userLanguage : 'es');

                    this.router.navigateByUrl('');
                } else {
                    this.loginModel.error = true;
                }
            }, error => {
                console.log('FuseLogin2Component > login > error', error);
                this.loginModel.loading = false;
                this.loginModel.error = true;
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/authentication/login-2/login-2.component.ts